import type { MonospaceInvite, MonospaceWorkspaceMember } from '#layers/data-model/public';
import { RStoreSchema } from '#imports';
import { deleteMembers } from '~/rstore/utils/collections/members';
import { defineSystemDateTimeFields, defineSystemDateTimeFieldTypes } from '~/rstore/utils/system-datetime-fields';

const MEMBER_DATETIME_FIELDS = ['lastActivityAt'] as const;

export const WorkspaceMember = RStoreSchema.withItemType<MonospaceWorkspaceMember>().defineCollection({
	name: 'MonospaceSystemUser',
	fields: defineSystemDateTimeFields(MEMBER_DATETIME_FIELDS),
	meta: {
		defaultFields: ['id', 'email', 'fullName', 'isService', 'lastActivityAt'],
		useWorkspaceSlug: true,
		fetchOnCreate: true,
		endpoint: {
			many: 'members',
		},
		primitiveFieldTypes: defineSystemDateTimeFieldTypes(MEMBER_DATETIME_FIELDS),
	},
	hooks: {
		async delete({ key }) {
			await deleteMembers([key as string]);
		},
		async deleteMany({ keys }) {
			await deleteMembers(keys as string[]);
		},
	},
});

export const WorkspaceInvite = RStoreSchema.withItemType<MonospaceInvite>().defineCollection({
	name: 'MonospaceWorkspaceInvite',
	scopeId: 'monospace-default',
	meta: {
		defaultFields: [
			'id',
			'email',
			'workspaceId',
			'workspaceRoles',
			'orgRoleId',
			'invitedById',
			'expiresAt',
			'createdAt',
		],
		useWorkspaceSlug: true,
		endpoint: 'invites',
	},
});
